import { render, staticRenderFns } from "./AdjustmentsDetails.vue?vue&type=template&id=3f53cdcc&scoped=true"
import script from "./AdjustmentsDetails.vue?vue&type=script&lang=js"
export * from "./AdjustmentsDetails.vue?vue&type=script&lang=js"
import style0 from "./AdjustmentsDetails.vue?vue&type=style&index=0&id=3f53cdcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f53cdcc",
  null
  
)

export default component.exports